import type { FC } from 'react'
import React from 'react'
import styles from './AddressEmptyState.module.scss'
import { Translator } from '@/tools/i18n'

interface Props {
  searchQuery: string
}
export const AddressEmptyState: FC<Props> = ({ searchQuery }) => (
  <div className={styles.addressEmptyState} data-testid="search-empty-state">
    <Translator
      keyText="address-search.no--results"
      params={{ searchQuery: <strong className={styles.highlighted}>{searchQuery}</strong> }}
    />
  </div>
)
